<script lang="ts">
  import WebhookInquiry from "../../organisms/settings/WebhookInquiry.svelte";
  import WebhookLpInquiry from "../../organisms/settings/WebhookLpInquiry.svelte";
</script>

<div class="flex">
  <div class="flex-1 mr-8">
    <WebhookInquiry />
    <WebhookLpInquiry klass="mt-8" />
  </div>
</div>
